export default __webpack_public_path__ + "static/media/create-new.ed3af70b.svg";